import type React from 'react';

import { SelectionCard, SelectionCardGroup } from '@change/ds-forms';

import { useMembershipAmountSelector } from './hooks/useMembershipAmountSelector';

export const MembershipAmountSelector: React.FC = () => {
	const {
		data: {
			buttonAmounts,
			selection,
			amountErrorText,
			customAmount,
			customAmountLabel,
			currencySymbol,
			currencySymbolPosition,
		},
		actions: { handleAmountChange, handleCustomAmountFocus, handleCustomAmountChange },
	} = useMembershipAmountSelector();

	return (
		<div className="flex flex-col gap-2">
			<SelectionCardGroup
				name="contributionAmount"
				value={selection}
				onChange={handleAmountChange}
				label=""
				labelIsVisible={false}
				variant="compact-small"
				columns={3}
				cardsWrapperClassName="gap-2"
				aria-labelledby="change-contribution-form-heading"
				data-qa="selection-card-group"
			>
				{buttonAmounts.map(({ value, label }) => (
					<SelectionCard
						key={value}
						value={value}
						label={label}
						data-qa="contribution-amount-button"
						data-testid="contribution-amount-button"
						data-amount={value}
					/>
				))}
				<SelectionCard
					value="custom"
					label={customAmountLabel}
					data-qa="custom-amount-other-button"
					isInvalid={!!amountErrorText}
					data-testid="custom-amount-other-button"
					hasInput
					currencySymbol={currencySymbol}
					currencySymbolPosition={currencySymbolPosition}
					// oxlint-disable-next-line typescript/no-unsafe-assignment
					inputProps={
						{
							onFocus: handleCustomAmountFocus,
							onChange: handleCustomAmountChange,
							errorMessage: amountErrorText,
							value: customAmount,
							// TODO: Remove this casting when TextField props are typed to allow these attributes
							// https://change.atlassian.net/browse/CHANGE-77254
							'data-qa': 'custom-amount-input',
							// eslint-disable-next-line @typescript-eslint/no-explicit-any
						} as any
					}
				/>
			</SelectionCardGroup>
		</div>
	);
};
